import { render, staticRenderFns } from "./exercises-task.vue?vue&type=template&id=7fd28254"
import script from "./exercises-task.vue?vue&type=script&lang=js"
export * from "./exercises-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports